<template>
    <div>
        <div style="flex:1; overflow:hidden; display:flex; flex-direction:column; background-color: #fbfbfb; border-top-left-radius:24px; border-top-right-radius:24px; padding-top:24px; position:relative;">
            <div style="position:absolute;left:0px; top:0px; width:100%; height:100%; z-index:0;">
                <img :src="require('@/assets/img/friend_popup_background.jpg')" style="width:100%;height:100%;">
            </div>
            <div style="display:flex; position:relative;">
                <div style="color:#210F03; font-size:16px; font-weight:bold; padding-left:24px;" @click="closeAction">닫기</div>
                <div style="flex:1;"></div>
            </div>
            <div style="position:relative;">
                <div style="text-align:center; font-size:20px; font-weight:bold; color:#210F03; margin-top:30px;">내 친구 목록</div>
                <div style="text-align:center; font-size:14px; font-weight:500; color:#606060;margin-top:20px;">함께 훈련하고 응원할 친구들입니다.</div>
            </div>
            <div style="display:flex; padding:5px 5px 5px 12px; margin-top: 18px; position:relative;">
                <div style="display:flex; align-items: center; color:#606060; font-size:16px; font-weight:500;">친구 {{total_count | comma}}</div>
            </div>
            <div style="display:flex; position: relative; padding: 0 12px; margin-top: 20px;">
                <div style="width: 100%;">
                    <input type="text" style="width:100%; height:40px; background-color: #f5f5f5; padding-left: 38px; border: 1px solid #808080; border-radius: 12px;" v-model="searchWord" placeholder="검색" @keyup="enter($event)">
                    <div style="position: absolute; top: 50%; transform: translateY(-50%); left: 24px;">
                        <img style="width: 20px;" :src="require('@/assets/img/friends_search.png')" alt="">
                    </div>
                </div>
                <!-- <div style="display:grid;place-items: center;border-top:1px solid #d7d9d7; border-right:1px solid #d7d9d7; border-bottom:1px solid #d7d9d7; width:40px; height:40px; border-top-right-radius: 4px; border-bottom-right-radius:4px;" @click="refresh">
                    <img style="width: 16px;" :src="require('@/assets/img/search_gray2.png')" alt="">
                </div> -->
            </div>
            <div style="flex:1; overflow:hidden; margin-top: 20px;">
                <InfinityScroll style="height:100%;" :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage">
                    <div v-for="each, i in friends" :key="i" style="display:flex; padding:12px;" @click="showProfile(each.member_idx)">
                        <div>
                            <div style="width:50px; height:50px; border:2px solid #808080; border-radius:50%;"><ProfileImage style="width: 46px; height:46px;" :image-path="each.image_path" :is-show-border="false"/></div>
                        </div>
                        <div style="flex:1; padding-top:7px; padding-left:5px;">
                            <div style="color:black; font-weight:bold; font-size:16px;">{{each.nic_name}}</div>
                            <div style="color:#808080; font-size:12px; font-weight:500; margin-top:7px;">{{each.place_name}}</div>
                        </div>
                        <div v-if="each.is_liked == 1" style="display:grid; place-items: center; color:#606060; font-weight:500; font-size:14px;">🧡 응원하는 친구</div>
                        <div v-else style="display:grid; place-items: center; color:#606060; font-weight:500; font-size:14px;">⚽ 익숙한 친구</div>
                    </div>
                </InfinityScroll>
            </div>

        </div>
    </div>
</template>

<script>
    import InfinityScroll from "../../common/InfinityScroll";
    import ProfileImage from "../../common/ProfileImage";
    import {MEMBER_TYPE} from "../../../Constants";
    export default {
        name: "MyFriendsPopup",
        components: {ProfileImage, InfinityScroll},
        data(){
            return {
                isEnableNextPageHandle : true,
                page : 1,
                friends : [],
                searchWord : '',
                total_count : 0,
            }
        },
        methods : {
            showProfile(member_idx){
                this.$Util.showProfile(member_idx, MEMBER_TYPE.USER);
            },
            enter(e){
                if(e.keyCode === 13){
                    this.refresh();
                }
            },
            closeAction() {
                this.$GlobalStore.closeLastModal();
            },
            refresh(){
                this.isEnableNextPageHandle = true;
                this.page = 1;
                this.friends = [];
                this.getMyFriends();
            },
            handleNextPage(){
                this.page++;
                this.getMyFriends();
            },
            async getMyFriends(){
                this.isEnableNextPageHandle = false;

                const parameters = {};
                parameters.page = this.page;
                parameters.member_idx = this.$GlobalStore.loginInfo().idx;
                if(this.searchWord) parameters.searchWord = this.searchWord;
                if(this.page === 1) parameters.is_include_count = true;

                const res = await this.$Axios.get('/api/member/friend/mine', {params : parameters});
                const friends = res.data.member_friends;

                if(parameters.page === 1){
                    this.total_count = res.data.total_count;
                }

                if(friends.length > 0){
                    this.isEnableNextPageHandle = true;
                    this.friends = [...this.friends, ...friends];
                }
            }
        },
        created() {
            this.getMyFriends()
        }
    }
</script>

<style scoped>
    input{border: 1px solid #d7d9d7; padding: 6px 12px; outline: none; font-size:14px; font-weight:500; color: #555;; width:100%;}
    input::placeholder{color:#d7d9d7;}
</style>